import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    serverUrl: 'https://communitybotbyzwizai.herokuapp.com/',
    query: {},
    profile: {},
  },
  mutations: {
  },
  actions: {
    sendMessage({ state }, message) {
      var vm = this;
      return new Promise(async (resolve) => {
        var url = state.serverUrl + "zwiz-pushmsg-webbrowser";
        var data = {
          pageid: state.query.pageid,
          userid: state.userid,
          message,
        };
        if (await window.liff.isInClient()) {
          try {
            await window.liff.sendMessages([
              {
                text: message,
                type: "text",
              },
            ]);
            resolve();
          } catch (error) {
            alert(JSON.stringify(error));
            alert(JSON.stringify(error.message));
          }
        } else {
          axios
            .post(url, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                resolve();
              } else {
                if (response.data.reason) {
                  await Swal.fire({
                    text: response.data.reason,
                  });
                  resolve();
                }
              }
            });
        }
      });
    },
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() { },
        function error() {
          window.close();
        }
      );
    }
  },
  modules: {
  }
})
